module.exports = __webpack_public_path__ + "img/index_list_item_icon_4.3a0afb2c.svg";